// Email & sales scripts — one follow-up per service page, in Todd's voice.
// [Bracketed] bits get swapped before sending. These are copy-paste templates
// for the dashboard; they are not sent automatically anywhere.

export const SALES_SCRIPTS = [
  {
    id: "ai-checklist-followup",
    title: "AI checklist follow-up",
    when: "Send 2–3 days after someone emails themselves the AI Answer Checklist",
    subject: "Your AI checklist — quick follow-up from Todd",
    body: `Hi there,

Todd from ZD Design here — you grabbed our AI Answer Checklist a little while back, so I wanted to check in.

Quick question: when you ask ChatGPT or Gemini for a good [your trade] in [your city], does it say your business? Most owners have never checked — it takes 30 seconds, and it's where a growing chunk of your customers are looking first.

The seven steps on that checklist are the same routine we run for clients every month. If you'd rather have it handled while you run the business, that's our AI Search Visibility program — and the first conversation is free.

Either way, hit reply and tell me what the machines say about you. I answer every message myself.

— Todd Meisler
ZD Design Agency · zddesignagency.com
Grab a free call: https://www.zddesignagency.com/free-strategy-call`,
  },
  {
    id: "repair-outreach-contractors",
    title: "Repair outreach — contractors (follow-up)",
    when: "Send 2–3 days after a first touch to contractors & home-service owners you found through search",
    subject: "Quick follow-up + a free mini gap report",
    body: `Hi [Name],

Hope you're doing well. I'm following up on the email I sent a few days ago.

I run ZD Design, a Kansas City company that helps contractors and home service businesses with website repairs and marketing. I came across your business looking for contractors in MO, took a look at your website, and wanted to offer a complimentary mini gap report.

The review/report would identify opportunities to improve your website and help potential customers find you through Google and AI search. No obligation—just practical recommendations to help you move forward and get the phone ringing. I am for real here...

Would you be open to a 10-minute conversation? If so, I'll prepare the review so we have something specific to discuss. You're also welcome to look at my 97 LinkedIn recommendations to learn more about my work.

Also, are you involved with the ACA Business Club in St. Louis? If not, I'd be happy to arrange a free guest visit to the ACA in St Louis for you, so you can meet other business owners and introduce your company.

Hope to connect soon. If you want to speak, please let me know.

Thanks!
Todd`,
  },
  {
    id: "website-optimization",
    title: "Website Design & Optimization",
    when: "Slow or dated site, high bounce, or a redesign they keep putting off",
    subject: "Your website — the 5-second test",
    body: `Hi [Name],

Todd from ZD Design. Quick one: pull your site up on your phone and give it five seconds. Would a stranger know what you do, who it's for, and who to call? If you had to scroll, pinch or squint — that's the leak.

The five-second test is the start of our Website Design & Optimization work: faster loading, sharper message, clearer next step. One client's rebuilt pages turned the same traffic into 300% more leads in 60 days.

Worth a look? Grab a free call and I'll walk your top three pages with you, live.

— Todd Meisler
ZD Design Agency · zddesignagency.com
Grab a free call: https://www.zddesignagency.com/free-strategy-call`,
  },
  {
    id: "seo",
    title: "SEO & Google Visibility",
    when: "Ranking below competitors, thin traffic, or tired of paying for every click",
    subject: "Why they rank above you (it's fixable)",
    body: `Hi [Name],

Todd from ZD Design. When someone searches [main service] in [your city], the same few companies show up — is one of them you?

Google ranks three things: how clearly your pages answer the search, how easy your site is to use, and how much the rest of the web vouches for you. Most small-business sites get one of the three right. Fix the weakest one first and rankings start moving — realistically six to twelve months to strong positions, then it compounds.

Our SEO & Google Visibility program runs that whole routine for you, with a monthly dashboard so you can see it working.

Want to know your three weakest spots? Grab a free call — I'll tell you straight, even if the answer is "not us yet."

— Todd Meisler
ZD Design Agency · zddesignagency.com
Grab a free call: https://www.zddesignagency.com/free-strategy-call`,
  },
  {
    id: "ad-remarketing",
    title: "Google Ads Management",
    when: "Burning budget on ads, or wants calls without waiting on SEO",
    subject: "Your ads — who's actually watching them?",
    body: `Hi [Name],

Todd from ZD Design. Quick question about your Google Ads: do you know which searches produced your last five calls? If the answer is "the agency sends a report," that report is probably hiding the leak.

We run ads for a living: tight keyword groups, every ad pointed at one job, search-terms watched daily, junk cut before it eats budget. One client grew from roughly $1M to $4M with this playbook doing the heavy lifting on paid search.

If your current setup can't answer the five-calls question, grab a free call and I'll pull the curtain on what daily management should look like.

— Todd Meisler
ZD Design Agency · zddesignagency.com
Grab a free call: https://www.zddesignagency.com/free-strategy-call`,
  },
  {
    id: "google-business-profile",
    title: "Google Business Profile & Local Search",
    when: "Weak map-pack presence, few or stale reviews, wrong info floating around",
    subject: "Your Google listing — the free storefront",
    body: `Hi [Name],

Todd from ZD Design. Your Google Business Profile is a storefront that's open at 2am — and for "near me" searches it decides who gets the call. Most profiles are half-filled: no services listed, old photos, reviews nobody answers.

Ours run a simple routine: complete info, right categories, steady fresh reviews, weekly posts. One client's profile went from invisible to the map pack — it's the cheapest marketing most businesses own and ignore.

Grab a free call and I'll score your profile on the spot — ten minutes, no strings.

— Todd Meisler
ZD Design Agency · zddesignagency.com
Grab a free call: https://www.zddesignagency.com/free-strategy-call`,
  },
  {
    id: "facebook-ads",
    title: "Facebook & Instagram Ads",
    when: "They sell on looks, trust or repeat business — or want cheaper awareness than search",
    subject: "People met you once — let's not make it weird",
    body: `Hi [Name],

Todd from ZD Design. Most businesses run Facebook ads at strangers once, get mediocre results, and quit. The money is in the sequence: introduce yourself, retarget the people who watched, then lookalikes of your best customers.

The ads that stop the scroll are the real ones — actual jobs, actual faces, actual offers. Meta's AI does the heavy lifting on delivery; our job is the feed: creative people actually engage with, and audiences that match how your customers buy.

One client hit 5 million social views in a month and 30% more subscriptions in 90 days. Grab a free call and I'll sketch the sequence for your business.

— Todd Meisler
ZD Design Agency · zddesignagency.com
Grab a free call: https://www.zddesignagency.com/free-strategy-call`,
  },
  {
    id: "coaching-consulting",
    title: "Marketing Strategy & Consulting",
    when: "Owner who does marketing themselves and wants a plan, not an agency",
    body: `Hi [Name],

Todd from ZD Design. Some owners don't want an agency — they want to know what to do themselves, in what order, and what to ignore. That's the consulting side of what we do.

We start with a straight read of where you stand: what your site says, what Google thinks, what your competitors spend, where the money actually comes from. Then a plan you can run — one hour at a time, no 40-page decks.

Grab a free call and bring your messiest marketing question. I'll give you a straight answer even if it doesn't lead to a sale.

— Todd Meisler
ZD Design Agency · zddesignagency.com
Grab a free call: https://www.zddesignagency.com/free-strategy-call`,
  },
  {
    id: "cross-web-repair",
    title: "Cross-Web Repair Program",
    when: "Broken, abandoned or hacked site — or a web person who vanished",
    body: `Hi [Name],

Todd from ZD Design. Quick one: when did someone last click through every page of your website? Broken forms, dead links and expired bits are invisible to you and expensive with customers — and Google notices too.

Our Cross-Web Repair Program exists exactly for sites past the patch stage: we audit the whole thing, fix what's broken, secure what's loose, and put a routine on top so it stays fixed.

If your site's been limping — or your last developer went quiet — grab a free call. Bring the URL, I'll tell you the three worst things on it, free.

— Todd Meisler
ZD Design Agency · zddesignagency.com
Grab a free call: https://www.zddesignagency.com/free-strategy-call`,
  },
  {
    id: "ai-search-visibility",
    title: "AI Search Visibility (GEO)",
    when: "Wants to be the business ChatGPT, Gemini and Claude recommend",
    subject: "What does AI say about your business?",
    body: `Hi [Name],

Todd from ZD Design. Here's a 30-second experiment: ask ChatGPT or Gemini "who's a good [your trade] in [your city]?" — then read the answer carefully.

If your name isn't in it, that's not bad luck. AI engines name whoever has the clearest facts, the most quotable answers, the strongest reviews and the most trust around the web. That's a routine, not luck — the same one every month: facts aligned, citable pages published, authority earned, results audited.

That's our AI Search Visibility program, $597/mo. Grab a free call and I'll show you what the machines currently say about your competitors — and what it would take to be the name they say.

— Todd Meisler
ZD Design Agency · zddesignagency.com
Grab a free call: https://www.zddesignagency.com/free-strategy-call`,
  },
];